/**
 * Expenses module routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { PK } from '@/constants/permissions';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { PermissionRoute } from '../PermissionRoute';

// Expenses pages
const ExpensesListPage = lazyWithRetry(() => import('@/features/expenses/pages/ExpensesListPage'));
const ExpenseDetailsPage = lazyWithRetry(() => import('@/features/expenses/pages/ExpenseDetailsPage'));
const ExpenseCreatePage = lazyWithRetry(() => import('@/features/expenses/pages/ExpenseCreatePage'));
const ExpenseEditPage = lazyWithRetry(() => import('@/features/expenses/pages/ExpenseEditPage'));

export const expensesRoutes: RouteObject[] = [
      // --------------------------------
      // Expenses Module
      // --------------------------------
      {
        path: ROUTES.expenses.list,
        element: (
          <PermissionRoute permission={PK.Expenses.OwnView}>
            <ExpensesListPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.expenses.all,
        element: (
          <PermissionRoute permission={PK.Expenses.AllView}>
            <ExpensesListPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.expenses.create,
        element: (
          <PermissionRoute permission={PK.Expenses.OwnCreate}>
            <ExpenseCreatePage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.expenses.details,
        element: (
          <PermissionRoute anyOf={[PK.Expenses.OwnView, PK.Expenses.AllView]}>
            <ExpenseDetailsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.expenses.edit,
        element: (
          <PermissionRoute permission={PK.Expenses.OwnEdit}>
            <ExpenseEditPage />
          </PermissionRoute>
        ),
      },
];
